<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div>
                    <h2 class=" font-bold text-xl leading-tight">
                    <i class="fas fa-hand-holding-usd"></i>
                        Enviar
                    </h2>
                </div>
                <Balance :short="true"/>
            </div>
        </template>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <section class="mx-4 xl:mx-32 lg:mx-20 md:mx-3 xl:mt-16 lg:mt-16 md:mt-6 sm:mt-6 mt-4">
                <flash :timeout="5000" />
                <Slider v-if="showSlider" :stages="sliderStages" />
                <div class="px-1 lg:px-5">
                    <SelectFavored
                        v-show="sections.selectFavored"
                        :favoreds="favoreds"
                        :accounts="accounts"
                        @back="$emit('back')"
                        @next="next"
                        @refresh-favored="getFavored"
                    />
                    <FormValueDetails
                        v-if="sections.valueDetails"
                        :favored="favored"
                        @go-back="goBack"
                    />
                </div>
            </section>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout.vue";
import SelectFavored from "./SelectFavored.vue";
import Slider from "../components/Slider.vue";
import Balance from "../../../Helpers/Balance.vue";
import FormValueDetails from "./FormValueDetails.vue";
import Flash from '../../../Helpers/Flash.vue';
import _ from 'lodash'

export default {
    name: "SendTed",
    props: {
        goal_list: { type: Array, required: true }
    },
    data: () => ({
        showSlider: true,
        sections: {
            selectFavored: false,
            valueDetails: false,
        },
        favored: {},
        favoreds: {
            content: [],
            loading: false
        },
        accounts: {
            content: [],
            loading: false
        }
    }),
    computed: {
        sliderStages(){
            return [{
                    titleStage: 'Modalidade de envio',
                    percentage: '0%',
                    selected: false,
                    completed: true
                },
                {
                    titleStage: 'Favorecido',
                    percentage: '50%',
                    selected: this.sections.selectFavored,
                    completed: this.sections.valueDetails,
                },
                {
                    titleStage: 'Valor e detalhes',
                    percentage: '98.7%',
                    selected: this.sections.valueDetails,
                    completed: this.sections.valueDetails,
                }]
        }
    },
    methods: {
        next(favored){
            this.favored = favored
            this.sections.selectFavored = false
            this.sections.valueDetails = true
        },
        goBack(){
            this.sections.selectFavored = true
            this.sections.valueDetails = false
        },
        getFavored: _.debounce(function(favored = '') {
            this.favoreds.loading = true
            axios
                .get(`/json/contacts?q=${favored}`)
                .then(({ data }) => this.favoreds.content = data.list)
                .finally(() => this.favoreds.loading = false)
        }, 400),
    },
    beforeMount() {
        this.favoreds.loading = true
        this.getFavored()
        setTimeout(() => (this.sections.selectFavored = true), 0);
    },
    components: {
        AppLayout,
        SelectFavored,
        Slider,
        Balance,
        FormValueDetails,
        Flash
    }
};
</script>
